import { render, staticRenderFns } from "./StatisticsFees.vue?vue&type=template&id=82184444&scoped=true&"
import script from "./StatisticsFees.vue?vue&type=script&lang=js&"
export * from "./StatisticsFees.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsFees.vue?vue&type=style&index=0&id=82184444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82184444",
  null
  
)

export default component.exports